/* eslint-disable react/destructuring-assignment */

import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import cn from 'classnames'
import React from 'react'
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'
import { NXDropdownWrapper } from './NXDropdownStyle'

const Arrow = styled(ArrowDropDown)`
  && {
    height: 35px;
    color: #6b6c72;
  }
`

const GlobalStyles = createGlobalStyle`
  .filter-dropdown {
    display: flex;
    flex-flow: row wrap;
    flex-grow: 1;
    justify-content: flex-end;
    .filter__field {
      margin-right: 8px;
    }
    .dropdown {
      margin-top: 5px;
      margin-bottom: 7px;
      .dropdown-button {
        margin: 0;
        min-height: auto;
      }
    }
  }
`

class Dropdown extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showContent: props.showContent,
    }
    this.showDropdown = this.showDropdown.bind(this)
    this.closeDropdown = this.closeDropdown.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.showContent !== nextProps.showContent) {
      this.setState({
        showContent: nextProps.showContent,
      })
    }
  }

  showDropdown() {
    // event.preventDefault();
    this.setState({ showContent: true }, () => {
      document.addEventListener('click', this.closeDropdown)
    })
  }

  closeDropdown(event) {
    // event.preventDefault();
    if (this.dropdownMenu && !this.dropdownMenu.contains(event.target)) {
      this.setState({ showContent: false }, () => {
        document.removeEventListener('click', this.closeDropdown)
      })
    }
  }

  render() {
    const { value, className, children } = this.props

    return (
      <ThemeProvider theme={theme}>
        <NXDropdownWrapper className="dropdown">
          {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
          <div role="presentation" onClick={this.showDropdown} className={cn(className, 'dropdown-button')}>
            <div className="dropdown-text">{value}</div>
            <Arrow />
          </div>
          {this.state.showContent && (
            <div
              ref={_element => {
                this.dropdownMenu = _element
              }}
              className="dropdown-content"
            >
              {children}
            </div>
          )}
          <GlobalStyles />
        </NXDropdownWrapper>
      </ThemeProvider>
    )
  }
}

Dropdown.defaultProps = {
  value: '',
  showContent: false,
}

export default Dropdown
